import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Immutable } from 'nuclear-js';
import CreateReactClass from 'create-react-class';

export default CreateReactClass({
    displayName: 'save-data-prompt',

    getInitialState() {
        return {
            show: false,
        };
    },

    promise: null,
    resolve: null,
    reject: null,

    show() {
        this.setState({ show: true });
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        return this.promise;
    },

    onContinue() {
        this.reject();
        this.setState({ show: false });
    },

    onDiscard() {
        this.resolve();
        this.setState({ show: false });
    },

    render() {
        const message = <p key="message">Your edits have not been saved</p>;
        const buttons = [
            <Button
                key="continue-button"
                id="save-data-prompt-continue-button"
                bsClass="cancel-button btn"
                onClick={this.onContinue}
            >
                Continue editing
            </Button>,
            <Button
                key="discard-button"
                id="save-data-prompt-discard-button"
                bsClass="ok-button btn"
                onClick={this.onDiscard}
            >
                Discard
            </Button>,
        ];

        return (
            <Modal
                id="save-data-prompt"
                bsSize="lg"
                aria-labelledby="save-data"
                onHide={this.onContinue}
                bsClass="growth-goal-modal modal"
                show={this.state.show}
            >
                <Modal.Header key="header" closeButton={true}>
                    <Modal.Title>Warning</Modal.Title>
                </Modal.Header>
                <Modal.Body key="body">{message}</Modal.Body>
                <Modal.Footer>{buttons}</Modal.Footer>
            </Modal>
        );
    },
});
